import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';
import { IKeyValue, KeyValueEntity } from './BasicEntities';

export interface IProductBrush {
    types: IKeyValue[];
    shapes: IKeyValue[];
}

class Types extends KeyValueEntity {}
class Shapes extends KeyValueEntity {}

export class ProductBrush {
    public types: KeyValueEntity[] = [];
    public shapes: KeyValueEntity[] = [];

    public static fromPlainObject(payload: ProductBrush): ProductBrush {
        const brush = new ProductBrush();
        copyPropertiesExcludeNullsAndGetters(brush, payload);

        return brush;
    }

    public static fromJson(brush: IProductBrush): ProductBrush {
        const newBrush = new ProductBrush();
        if (!brush) {
            return newBrush;
        }

        newBrush.types = brush.types
            ? brush.types.map((data) => {
                  return Types.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        newBrush.shapes = brush.shapes
            ? brush.shapes.map((data) => {
                  return Shapes.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        return newBrush;
    }

    public toJSON(): IProductBrush {
        return {
            types: this.types,
            shapes: this.shapes
        };
    }
}
